import { CondoTypeEnum } from '~/core/entities/CRMCondoEnums';
import { PropertyTypeEnum } from '~/core/entities/CRMEnums';

export interface MapCondominiumConfigOptions {
	gestureHandling?: 'cooperative' | 'greedy' | 'none';
	streetViewControl?: boolean;
	mapTypeControl?: boolean;
	fullscreenControl?: boolean;
	zoomControl?: boolean;
	scrollwheel?: boolean;
	cameraControl?: boolean;
	disableDefaultUI?: boolean;
	clickableIcons?: boolean;
	center?: google.maps.LatLng | google.maps.LatLngLiteral;
}

export interface MapCondominiumConfig {
	draggable: boolean;
	clickableIcons?: boolean;
}

export interface MapMarkerCondominiumConfig {
	draggable: boolean;
	zIndex: number;
	title?: string;
}

export const MapCondominiumConfig: MapCondominiumConfig = {
	draggable: false,
	clickableIcons: false
} as const;

export const MapCondominiumConfigOptions: MapCondominiumConfigOptions = {
	gestureHandling: 'cooperative',
	streetViewControl: false,
	mapTypeControl: false,
	fullscreenControl: false,
	zoomControl: false,
	scrollwheel: false
} as const;

export const MapMarkerCondominiumConfig: MapMarkerCondominiumConfig = {
	draggable: false,
	zIndex: 9999
} as const;

export const condoTypeByPropertyType: Record<
	CondoTypeEnum,
	PropertyTypeEnum[]
> = {
	[CondoTypeEnum.VERTICAL]: [
		PropertyTypeEnum.APARTMENT,
		PropertyTypeEnum.DUPLEX,
		PropertyTypeEnum.FLAT,
		PropertyTypeEnum.GARDEN,
		PropertyTypeEnum.LOFT,
		PropertyTypeEnum.PENTHOUSE,
		PropertyTypeEnum.STUDIO,
		PropertyTypeEnum.TRIPLEX
	],
	[CondoTypeEnum.HORIZONTAL]: [
		PropertyTypeEnum.HOUSE,
		PropertyTypeEnum.VILLAGE_HOUSE,
		PropertyTypeEnum.CONDO_HOUSE,
		PropertyTypeEnum.CONDO_LAND,
		PropertyTypeEnum.LAND
	]
};
